import React, { useEffect, useState } from "react";
import { PIECES_SHORT } from "../../../constants/pieceItems";

export default function MainPieceDesc({ pieceItems,animIndex, setAnimIndex }) {
  const ArrObj0 = [
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
  ];
  const ArrObj1 = [
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
  ];
  const ArrObj2 = [
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
  ];
  const ArrObj3 = [
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
  ];
  const ArrObj4 = [
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
  ];
  const ArrObj5 = [
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
  ];
  const ArrObj6 = [
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
  ];
  const ArrObj7 = [
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
  ];
  const ArrObj8 = [
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#FEC42B",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
    {
      bgColor: "#D9D9D9",
    },
  ];

  const [arr, setArr] = useState(ArrObj1);
  useEffect(() => {
    switch(animIndex){
      case 0:{
        setArr(ArrObj0)
        break
      }
      case 1:{
        setArr(ArrObj1)
        break
      }
      case 2:{
        setArr(ArrObj2)
        break
      }
      case 3:{
        setArr(ArrObj3)
        break
      }
      case 4:{
        setArr(ArrObj4)
        break
      }
      case 5:{
        setArr(ArrObj5)
        break
      }
      case 6:{
        setArr(ArrObj6)
        break
      }
      case 7:{
        setArr(ArrObj7)
        break
      }
      case 8:{
        setArr(ArrObj8)
        break
      }
    }
  }, [animIndex]);

  return (
    <div className="absolute bottom-[20px] h-[150px] w-[419px] flex flex-col items-center justify-between bg-color-primary-A">
       <div className="relative ">
          <span className="absolute top-[-30px] left-[-10px] font-font_primary_A  text-color-primary-D text-[16px] bg-color-primary-A">0%</span>
          <span className="absolute top-[-30px] right-[-20px] font-font_primary_A  text-color-primary-D text-[16px] bg-color-primary-A">100%</span>
          <div className="w-[416px] flex items-center justify-between">
            {arr.map((item) => (
              <div
                style={{ backgroundColor: `${item.bgColor}` }}
                className={`w-[3px] h-[15px]`}
              ></div>
            ))}
          </div>
          <div className="w-[416px] border-[1px] border-[#02161D]  mt-[10px]"></div>
        </div>

      <span dir="rtl" className="w-full flex-1 min-h-[50px]   font-medium text-[12px] text-color-primary-D mt-[12px] text-justify ">
        {pieceItems.find((item) => item.id == animIndex)?.desc}
      </span>
    </div>
  );
}
